<div class="container">
  <!-- Title -->
  <div class="text-center">
    <strong class="mainHeading">User On & Off Business</strong>
  </div>
  <div class="row mb-3 mt-3">
    <div class="col-md-2">
      <label for="userType">Select User Type</label>
      <select
        id="userType"
        class="form-select"
        (change)="onUserTypeChange($event)"
      >
        <option value="">All</option>
        <option *ngFor="let type of userTypeList" [value]="type.id">
          {{ type.userType }}
        </option>
      </select>
    </div>
    <div class="col-md-2">
      <label for="city">Select City</label>
      <select id="city" class="form-select" (change)="onCityChange($event)">
        <option value="">All Cities</option>
        <option *ngFor="let city of cityList" [value]="city.id">
          {{ city.cityName }}
        </option>
      </select>
    </div>
    <div class="col-md-2">
      <label for="zone">Select Zone</label>
      <select id="zone" class="form-select" (click)="onZoneChange($event)">
        <option value="">All Zones</option>
        <option *ngFor="let zone of zoneList" [value]="zone.zoneId">
          {{ zone.zoneName }}
        </option>
      </select>
    </div>
    <div class="col-md-6"></div>
  </div>
 
  <!-- Filter buttons and search input -->
  <div class="d-flex justify-content-between mb-3">
    <div>
      <button class="btn btn-success me-2" (click)="exportToExcel()">
        <i class="bi bi-download me-1"></i> Export
      </button>
 
      <button
        class="btn btn-outline-secondary me-2"
        type="button"
        ngbTooltip="Print"
        (click)="exportToPDF()"
      >
        <i class="bi bi-printer me-1"></i> Print
      </button>
 
      <button class="btn btn-danger" (click)="clearFilters(searchInput)">
        <i class="bi bi-x-circle me-1"></i> Clear
      </button>
    </div>
  </div>
 
  <!-- Table of users -->
  <div class="card shadow-lg p-3">
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-3"
    >
      <h2 class="mb-0">On & Off Business List</h2>
      <div class="col-lg-3 col-md-4 col-sm-12 mt-2 mt-md-0">
        <input
        #searchInput
          type="text"
          class="form-control"
          placeholder="Search"
          [(ngModel)]="searchText"
          (keyup)="search($event)"
        />
      </div>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="activeTab == 'onBusiness'"
          (click)="setActiveTab('onBusiness')"
        >
          User On Business
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="activeTab == 'offBusiness'"
          (click)="setActiveTab('offBusiness')"
        >
          User Off Business
        </a>
      </li>
    </ul>
 
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="bg-success text-white">
          <tr>
             <th>S.No</th>
            <th>User Type</th>
            <th>User Name</th>
            <th>Mobile Number</th>
            <th>City</th>
            <th>Zone</th>
            <th>Date Registered</th>
            <th>User Platform</th>
            <th>Platform Version</th>
            <th>User Business Status</th>
            <th>User Approval Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of pagedData; let i = index">
              <td class="text-center">{{ getSerialNumber(i) }}</td>
            <td>{{ user.userType }}</td>
            <td>
              {{
                user.userType === "Individual Requester"
                  ? user.username
                  : user.companyName
              }}
            </td>
            <td>{{ user.mobileNumber }}</td>
            <td>{{ user.city }}</td>
            <td>{{ user.zone }}</td>
            <td>{{ user.userRegisteredDate | date : "dd MMM yyyy" }}</td>
            <td>{{ user.userPlatform }}</td>
            <td>{{ user.platformVersion }}</td>
            <td>{{ user.userBusinessStatus }}</td>
            <td>{{ getStatus(user.userApprovalStatus, user.userType) }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="pagedData?.length === 0">
        <app-no-data-found></app-no-data-found>
      </div>
      <div
        class="d-flex justify-content-between align-items-center mt-3 flex-wrap"
      >
        <!-- Entries per page select -->
        <div class="mb-2 mb-md-0">
          <label class="me-2 fw-semibold">Show</label>
          <select
            class="form-select d-inline-block w-auto"
            [(ngModel)]="pageSize"
            (change)="onPageChange(1)"
          >
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }}
            </option>
          </select>
          <span class="ms-2 fw-semibold">entries</span>
        </div>
 
        <!-- Pagination in center -->
        <div class="d-flex justify-content-center flex-grow-1">
          <ngb-pagination
            *ngIf="pagedData?.length > 0"
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="filterBuisnessUsers?.length"
            [maxSize]="3"
            (pageChange)="onPageChange($event)"
            [boundaryLinks]="true"
          >
          </ngb-pagination>
        </div>
 
        <!-- Showing X to Y of Z entries -->
        <div *ngIf="pagedData?.length > 0" class="text-muted mb-2 mb-md-0">
          <strong>
            Showing {{ (page - 1) * pageSize + 1 }} to
            {{
              page * pageSize > filterBuisnessUsers?.length
                ? filterBuisnessUsers?.length
                : page * pageSize
            }}
            of {{ filterBuisnessUsers?.length }} entries
          </strong>
        </div>
      </div>
    </div>
  </div>
</div>
 